import { Component, ChangeDetectionStrategy } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
	selector: "stages-proxy",
	templateUrl: "./proxy.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [RouterOutlet],
})
export class ProxyComponent {}
